const routes = {
  offers: "/offers",
  offerDetails: "/offerDetails",
  collections: "/collections",
  merchants: "/merchants",
};

export default routes;
